/**
 * Returns a date string with an offset in days, hours, and minutes.
 */
export function getDateOffset(days: number, hours: number, minutes = 0): string {
  const date = new Date();
  date.setDate(date.getDate() + days);
  date.setHours(hours, minutes, 0, 0);
  return date.toISOString();
}

/**
 * Returns a date string with an offset in minutes from now.
 */
export function getDateOffsetRelative(minutes: number): string {
  const date = new Date();
  date.setMinutes(date.getMinutes() + minutes);
  return date.toISOString();
}

/**
 * Returns the current date as an ISO string.
 */
export function nowIso(): string {
  return new Date().toISOString();
}
